//import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        ivaText: {
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
    },
    variants: {
        tile: {
            ivaText: {
                textStyle: 'body-xxsmall',
                color: 'text.secondary',
                width: 'auto',
            },
        },
        OrderDetail: {
            ivaText: {
                width: 'auto',
                color: 'inherit',
            },
        },
        vatNoWrap: {
            ivaText: {
                whiteSpace: 'nowrap',
            },
        },
    },
    parts: ['ivaText'],
}
